import { type ControlType, type SpendingControlWithUsage } from "../types";

/**
 * Selects a single workplace's control of a given type.
 *
 * The v2 spending-controls endpoint returns one row per workplace — the requested workplace plus its
 * corporate siblings — for CBH employees and corporate admins. Single-workplace consumers MUST match on
 * `workplaceId` as well as `controlType`, otherwise `.find()` can return a sibling's row (order is
 * nondeterministic). Centralized here so every such consumer scopes the same way.
 */
export function findControlForWorkplace(
  controls: SpendingControlWithUsage[],
  params: { controlType: ControlType; workplaceId: string }
): SpendingControlWithUsage | undefined {
  return controls.find(
    (control) =>
      control.controlType === params.controlType && control.workplaceId === params.workplaceId
  );
}
